import './PricingCTA.css';

export default function PricingCTA() {
  return (
    <section className="pricing-cta-section" aria-label="Pricing support offer">
      <aside className="pricing-cta" aria-labelledby="pricing-cta-title">
        <div className="pricing-cta-copy">
          <span className="pricing-cta-tag">Included with every paid plan</span>
          <div>
            <h3 id="pricing-cta-title">Setup and onboarding are included.</h3>
            <p>We’ll help configure SmushChat around your approved content, brand, and workflows.</p>
          </div>
        </div>

        <div className="pricing-cta-actions">
          <div className="pricing-cta-includes" aria-label="Offer includes">
            <span><i aria-hidden="true">✓</i> Hands-on setup</span>
            <span><i aria-hidden="true">✓</i> Team training</span>
            <span><i aria-hidden="true">✓</i> Brand &amp; workflow tailoring</span>
          </div>
          <a href="/pricing" className="pricing-cta-button">
            View paid plans
            <svg viewBox="0 0 20 20" aria-hidden="true">
              <path d="M4 10h12M11 5l5 5-5 5" />
            </svg>
          </a>
        </div>
      </aside>
    </section>
  );
}
